import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import "./Modal.scss";

const Modal = (props) => {
  const className = props.className
      ? `${props.className} instream-modal`
      : "instream-modal";

  return (
    <Dialog
      className={className}
      title={props.title}
      onClose={props.onCancel}
    >
      {props.children}
    </Dialog>
  );
};

export default Modal;
